import { render, staticRenderFns } from "./DisqualificationConfirm.vue?vue&type=template&id=4785106e"
import script from "./DisqualificationConfirm.vue?vue&type=script&lang=js"
export * from "./DisqualificationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports